import React from 'react';
import { Select } from 'antd';

const SelectServiceInvoiceTaxLocation = ({ ...rest }) => {
  return (
    <Select {...rest}>
      <Select.Option value="companyMunicipality">
        No município da empresa
      </Select.Option>
      <Select.Option value="customerMunicipality">
        No município do cliente
      </Select.Option>
      <Select.Option value="serviceProvisionMunicipality">
        No município de prestação do serviço
      </Select.Option>
    </Select>
  );
};

export default SelectServiceInvoiceTaxLocation;
